export const showToast = (message, type = 'success', context = null) => {
  if (!context) {
    context = window.location.pathname.startsWith('/admin') ? 'admin' : 'frontend';
  }

  const toastClass = context === 'admin' ? 'admin-toast' : 'app-toast';
  const existingToast = document.querySelector(`.${toastClass}`);

  if (existingToast) {
    existingToast.remove();
  }

  const toast = document.createElement('div');
  toast.className = `${toastClass} fixed bottom-8 left-8 z-50 max-w-md rounded-lg px-4 py-3 shadow-lg transition-all duration-300 transform translate-y-0 opacity-100`;

  const typeStyles = {
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    warning: 'bg-yellow-500 text-white',
    info: 'bg-blue-500 text-white'
  };

  toast.className += ` ${typeStyles[type] || typeStyles.info}`;

  toast.innerHTML = `
    <div class="flex items-center justify-between">
      <span class="font-medium">${message}</span>
      <button class="ml-4 text-white hover:text-gray-200 close-toast">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  `;

  document.body.appendChild(toast);

  const closeButton = toast.querySelector('.close-toast');
  closeButton.addEventListener('click', () => {
    removeToast(toast);
  });

  setTimeout(() => {
    removeToast(toast);
  }, 5000);
};

const removeToast = (toast) => {
  if (toast && toast.parentNode) {
    toast.style.transform = 'translateY(100%)';
    toast.style.opacity = '0';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }
};

// 為了向後相容，提供別名
export const showAdminToast = (message, type = 'success') => {
  return showToast(message, type, 'admin');
};

export const showFrontendToast = (message, type = 'error') => {
  return showToast(message, type, 'frontend');
};
